import { pathRedirect } from '@/utils/auth'
import useWater from '@/containers/Except/useWater'
import copyData from '@/containers/Except/copyData'

export default {
  path: 'except',
  redirect: pathRedirect,
  children: [
    { path: 'useWater', component: useWater, name: '用水异常' },
    { path: 'copyData', component: copyData, name: '抄表异常' }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/except.js